export default {
  /**
   * MLD-6456
   * @see https://chatgpt.com/c/a7fa47ce-ea13-45a4-b457-fc50e3e5ce2b
   * @param file
   * @returns {Promise<unknown>}
   */
  readFileContent(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsText(file); // Read the file as text
    });
  }
}
